import { Injectable } from "@angular/core";
import { take } from "rxjs/operators";
import { Observable, forkJoin } from "rxjs";
import { IPTrackerService } from "../tracking/ip-tracker-service";
import { StartUpConfigUiService } from './start-up-config-ui.service';

@Injectable({
  providedIn: 'root'
})
export class CjProcessTrackingUiService {

    ////For every virtualpage entry, add new promise.
    ////So that, its answer is added to datalayer ONLY after its virtual page.
    //private virtualPageTasks: VirtualPageTaskModel[] = [];
    ////private sessionTrackingId: string;
    ////Remove VirtualPageTask from Array, after its corresponding answer is added to datalayer.
    //private tryRemoveVirtualPageTask = (qKey: string) => {
    //    var virtualPageTaskIndex = this.virtualPageTasks.findIndex(x => x.qKey == qKey);
    //    if (virtualPageTaskIndex < 0) { return; }
    //    this.virtualPageTasks.splice(virtualPageTaskIndex, 1);
    //}

    constructor(
        private startUpConfigUiService: StartUpConfigUiService,
        private ipTrackerService: IPTrackerService
    ) { }

    //cjProcessQCounter(qKey: string) {
    //    this.counterService.cjProcessQCounter(qKey).pipe(take(1)).subscribe();
    //}

    //cjProcessVirtualPage(qKey: string, question: Question20<any>) {

    //    if (!question || !question.question) { return; }

    //    var virtualPageToDataLayer = (resolve) => {
    //        try {
    //            this.questionStockUiService.getCjQuestionIdentityByQKey(qKey).pipe(take(1)).subscribe({
    //                next: (qi) => {
    //                    this.sectionStockUiService.getSectionIdentityByName(qi.section).pipe(take(1)).subscribe({
    //                      next: (si) => {
    //                        this.startUpConfigUiService.sessionInfo$.subscribe({
    //                          next: (sessionInfo) => {
    //                            this.gtmDataLayerUiService.addVirtualPage(qKey, si.index, question.question,sessionInfo.abTestName, sessionInfo.abTestValue).subscribe({
    //                              next: () => {
    //                                resolve();
    //                              }
    //                            });
    //                          }
    //                        });
    //                        }
    //                    });
    //                }
    //            });
    //        } catch (error) {
    //            resolve();
    //        }
    //    };

    //    //Remove any virtual Page Tasks with same qKey.
    //    //Because cjProcessAnswer should wait only for latest one.
    //    this.tryRemoveVirtualPageTask(qKey);

    //    //Adding VirtualPage Task to Array will execute it.
    //    this.virtualPageTasks.push({ qKey: qKey, promise: new Promise(virtualPageToDataLayer) });
    //}

    //cjProcessValidationError(currentQuestionIdentity$: Observable<QuestionIdentityModel>, errorSummary: string) {

    //    currentQuestionIdentity$.pipe(take(1)).subscribe({
    //        next: (cqi) => {
    //            this.questionStockUiService.getCjQuestionIdentityByQKey(cqi.qKey).pipe(take(1)).subscribe({
    //                next: (qi) => {

    //                    this.sectionStockUiService.getSectionIdentityByName(qi.section).pipe(take(1)).subscribe({
    //                        next: (si) => {
    //                            this.gtmDataLayerUiService.addVirtualPageValidationError(cqi.qKey, si.index, errorSummary).subscribe();
    //                        }
    //                    });

    //                }
    //            });
    //        }
    //    });
    //}
   
    public initIpTracking(): void {
        forkJoin(
            this.startUpConfigUiService.initialConfig$.pipe(take(1)),
            this.startUpConfigUiService.deferredConfig$.pipe(take(1)),
            this.startUpConfigUiService.sessionInfo$.pipe(take(1))
        ).subscribe(([initialConfig, defferedConfig, sessionInfo]) => {

            //for performance purpose, loading additional scripts is delayed.
          setTimeout(() => {
                this.ipTrackerService.initIPTracker(defferedConfig.ipTrackerSettings, sessionInfo.sessionTrackingId);

            }, 2000);
        });
    }
    //cjProcessAnswer(qKey: string, answerStr: string) {

    //    if (!qKey || !answerStr) { return; }

    //    var addAnswer = () => {
    //        this.gtmDataLayerUiService.addAnswer(qKey, answerStr).subscribe();
    //    }

    //    var virtualPageTask = this.virtualPageTasks.find(x => x.qKey == qKey);

    //    //If there is pending virtualPage datalayer entry, lets wait,
    //    //to synchronize virtualpage and its answer datalayer entry.
    //    if (virtualPageTask) {
    //        virtualPageTask
    //            .promise
    //            .then(() => addAnswer())
    //            .then(() => this.tryRemoveVirtualPageTask(qKey));
    //    } else {
    //        addAnswer();
    //    }
    //}

}
